import {Component, OnInit} from '@angular/core';
import {EntityTypes, SpecLineModel, StateService} from "web-shared";
import {BaseComponent} from "common-shared";
import {takeUntil} from "rxjs/operators";
import {PROPERTIES} from "../../property.constants";

@Component({
  selector: 'mes-web-dashboard',
  templateUrl: './dashboard.component.html',
  styles: []
})
export class DashboardComponent extends BaseComponent implements OnInit {
  specs: SpecLineModel[];
  selectedTypes = [EntityTypes.Item, EntityTypes.ItemGroup, EntityTypes.Resource, EntityTypes.Configuration, EntityTypes.OrderLine];
  selectableTypes: { id: number, name: string }[] = [
    {name: EntityTypes[EntityTypes.Configuration], id: EntityTypes.Configuration},
    {name: EntityTypes[EntityTypes.OrderLine], id: EntityTypes.OrderLine},
    {name: EntityTypes[EntityTypes.ItemGroup], id: EntityTypes.ItemGroup},
    {name: EntityTypes[EntityTypes.Item], id: EntityTypes.Item},
    {name: EntityTypes[EntityTypes.Resource], id: EntityTypes.Resource}
  ];
  customSavedFilterTypes: {Key: string, Value: EntityTypes}[] = [{Key: PROPERTIES.OrderLinesListFilterSettings, Value: EntityTypes.OrderLine}];

  constructor(private stateService: StateService) {
    super();
  }

  ngOnInit() {
    this.loadSpecs();
  }

  loadSpecs() {
    this.stateService.currentUser$.pipe(takeUntil(this.componentDestroyed)).subscribe(user => {
      this.specs = user.Specs;
    });
  }
}
